import React, { Component, useState, useEffect } from "react";
import Footer from "./layouts/Footer";
import Navbar from "./layouts/Navbar";
import { WebLink, SiteWide } from "./customComponents";
import NoData from "./customComponents/NoData";
import FundRecordsNavigation from "./shared/FundRecordsNavigation";

import Section from "./layouts/Section";
import { useNavigate, useLocation } from 'react-router-dom';

import Slider from "react-slick";
import { Images } from "./customComponents";
import Colors from '../utility/Colors';
import Helper1, { notify, styles, money } from '../utility/Helper1';

import { depositActions } from '../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { allDepositSelect, userSelect, allRemoteSettingsSelect, homeScreenStatSelect } from '../redux/selectors/index';
import Modal from 'react-modal';
import LoadingOverlay from 'react-loading-overlay';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomAgo from "./customComponents/CustomAgo";

// Modern UI Icons
import {
    Wallet,
    TrendingUp,
    Clock,
    CheckCircle,
    AlertCircle,
    XCircle,
    Copy,
    Eye,
    EyeOff,
    History,
    ArrowRight,
    Filter,
    Search,
    Calendar,
    DollarSign,
    CreditCard,
    Banknote,
    Receipt
} from 'lucide-react';



function DepositHistory() {

    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const [loadingText, setLoadingText] = useState('Loading history...');

    const [loading, setloading] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [dataHasChanged, setDataHasChanged] = useState(false);
    const navigate = useNavigate();
    const [newDepositInfo, setNewDepositInfo] = useState([]);
    const [modalIsOpen, setIsOpen] = React.useState(false);

    const finance = useSelector(homeScreenStatSelect);

    const dispatch = useDispatch();
    const loadHistoryData = useSelector(allDepositSelect);


    const search = useLocation();
    const depositRequest = search?.state?.deposit;

    const loadAllDeposit = () => {

        setloading(true)
        setLoadingText('Loading payment history...')
        dispatch(depositActions.onLoadAllDeposits("deposit/load", response => {
            if (response.code == 1) {
                setloading(false)
                setDataHasChanged(!dataHasChanged)
            }
        }))

    }



    useEffect(() => {
        loadAllDeposit()
    }, [])



    useEffect(() => {

        let pendingDeposit = loadHistoryData?.filter((item, index) => item.status < 2)

        if (pendingDeposit?.length > 0) {
            setIsOpen(true);
            setNewDepositInfo(pendingDeposit)
        }

    }, [dataHasChanged])





    return (
        <SiteWide id="main" title="Fund Records">
            <Section loading={loading} overlayText={loadingText} title="Fund Records">
                <div className="min-h-screen p-4">
                    <div className="max-w-7xl mx-auto pt-8">
                        {/* Modern Header */}
                        <div className="text-center mb-12">
                            <h1 className="text-5xl font-bold text-white mb-4 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                                Fund Records
                            </h1>
                            <p className="text-xl text-blue-200">
                                Track your deposit and withdrawal history
                            </p>
                        </div>

                        <div className="flex flex-col gap-2">
                            <FundRecordsNavigation activeTab="deposits" />

                            {/* Deposit History Cards */}
                            <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-8 shadow-2xl">
                                <div className="mb-8">
                                    <h2 className="text-2xl font-bold text-white mb-2">Transaction History</h2>
                                    <p className="text-gray-300">Complete overview of your deposit transactions</p>
                                </div>

                                <div className="space-y-6">
                                    {loadHistoryData && loadHistoryData.length > 0 ? loadHistoryData.map((item, index) => {
                                        let image = finance?.filter((filitem, index) => filitem.type == item.currency);
                                        const statusConfig = {
                                            0: { label: 'Pending', icon: Clock, color: 'text-yellow-400', bgColor: 'bg-yellow-500/20', borderColor: 'border-yellow-400/30' },
                                            1: { label: 'Processing', icon: AlertCircle, color: 'text-blue-400', bgColor: 'bg-blue-500/20', borderColor: 'border-blue-400/30' },
                                            2: { label: 'Paid', icon: CheckCircle, color: 'text-green-400', bgColor: 'bg-green-500/20', borderColor: 'border-green-400/30' },
                                            3: { label: 'Cancelled', icon: XCircle, color: 'text-red-400', bgColor: 'bg-red-500/20', borderColor: 'border-red-400/30' }
                                        };
                                        const currentStatus = statusConfig[item?.status] || statusConfig[0];

                                        return (
                                            <div
                                                key={index}
                                                className="group relative p-6 bg-white/5 rounded-2xl border border-white/10 hover:bg-white/10 transition-all duration-300 hover:scale-[1.01] hover:shadow-xl overflow-hidden"
                                            >
                                                {/* Decorative gradient overlay */}
                                                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                                                <div className="relative flex items-center gap-4">
                                                    {/* Currency Icon */}
                                                    <div className="flex-shrink-0">
                                                        <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                                                            {image?.[0]?.image ? (
                                                                <Images height={32} source={image[0].image} alt="currency" />
                                                            ) : (
                                                                <DollarSign className="text-white" size={24} />
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Main Content */}
                                                    <div className="flex-1 min-w-0">
                                                        {/* Header Row */}
                                                        <div className="flex items-center justify-between mb-3">
                                                            <div>
                                                                <h3 className="text-white font-bold text-lg mb-1">Deposit Transaction</h3>
                                                                <div className="flex items-center gap-2">
                                                                    <Receipt className="text-gray-400" size={14} />
                                                                    <span className="text-gray-300 text-sm font-mono">{item.txn_id}</span>
                                                                    <CopyToClipboard text={item.txn_id}>
                                                                        <button className="text-gray-400 hover:text-white transition-colors p-1 rounded hover:bg-white/10">
                                                                            <Copy size={12} />
                                                                        </button>
                                                                    </CopyToClipboard>
                                                                </div>
                                                            </div>
                                                            <div className={`px-3 py-1.5 rounded-xl ${currentStatus.bgColor} border ${currentStatus.borderColor} flex items-center gap-2 shadow-lg`}>
                                                                <currentStatus.icon className={currentStatus.color} size={16} />
                                                                <span className={`text-sm font-semibold ${currentStatus.color}`}>
                                                                    {currentStatus.label}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Transaction Details - Horizontal Layout */}
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-6">
                                                                <div>
                                                                    <div className="flex items-center gap-1 mb-1">
                                                                        <DollarSign className="text-blue-400" size={14} />
                                                                        <span className="text-gray-300 text-xs">Amount to Pay</span>
                                                                    </div>
                                                                    <p className="text-white font-bold text-lg">
                                                                        {money(item?.amountEnforcedToPay, item?.currency)}
                                                                    </p>
                                                                </div>

                                                                <div>
                                                                    <div className="flex items-center gap-1 mb-1">
                                                                        <CheckCircle className="text-green-400" size={14} />
                                                                        <span className="text-gray-300 text-xs">Amount Paid</span>
                                                                    </div>
                                                                    <p className="text-green-400 font-bold text-lg">
                                                                        {money(item?.amountPaid, item?.currency)}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            {/* Timestamp */}
                                                            <div className="flex items-center gap-2 text-gray-400">
                                                                <Calendar className="text-gray-400" size={14} />
                                                                <CustomAgo time={item?.timestamp} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Progress indicator for pending/processing */}
                                                {item?.status < 2 && (
                                                    <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-500 via-blue-500 to-green-500 opacity-60"></div>
                                                )}
                                            </div>
                                        );
                                    }) : (
                                        <div className="flex flex-col items-center justify-center py-16 px-8 text-center">
                                            <div className="w-24 h-24 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-3xl flex items-center justify-center mb-6">
                                                <TrendingUp className="text-blue-400" size={40} />
                                            </div>
                                            <h3 className="text-2xl font-bold text-white mb-4">No Deposit Records</h3>
                                            <p className="text-gray-300 text-lg mb-6 max-w-md">
                                                You haven't made any deposits yet. Start your journey by making your first deposit to see your transaction history here.
                                            </p>
                                            <div className="flex flex-col sm:flex-row gap-4">
                                                <button onClick={() => navigate('/deposit')} className="px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl text-white font-semibold hover:from-blue-600 hover:to-purple-700 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-blue-500/25">
                                                    Make a Deposit
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>

            {/* Enhanced Pending Deposits Modal */}
            {modalIsOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setIsOpen(false)}></div>
                    <div className="relative w-full max-w-2xl bg-white/10 backdrop-blur-xl rounded-3xl border border-white/20 p-8 shadow-2xl">
                        <div className="flex items-center mb-6">
                            <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-orange-600 rounded-2xl flex items-center justify-center mr-4 shadow-lg">
                                <Clock className="text-white" size={20} />
                            </div>
                            <h2 className="text-2xl font-bold text-white">Pending Deposits</h2>
                        </div>

                        <div className="space-y-6 mb-8">
                            {newDepositInfo?.map((item, index) => {
                                let image = finance?.filter((filitem, index) => filitem.type == item.currency);
                                const statusConfig = {
                                    0: { label: 'Pending', icon: Clock, color: 'text-yellow-400', bgColor: 'bg-yellow-500/20', borderColor: 'border-yellow-400/30' },
                                    1: { label: 'Processing', icon: AlertCircle, color: 'text-blue-400', bgColor: 'bg-blue-500/20', borderColor: 'border-blue-400/30' }
                                };
                                const currentStatus = statusConfig[item?.status] || statusConfig[0];

                                return (
                                    <div
                                        key={index}
                                        className="group relative p-6 bg-white/5 rounded-3xl border border-white/10 hover:bg-white/10 transition-all duration-300 overflow-hidden"
                                    >
                                        {/* Decorative gradient overlay */}
                                        <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/5 to-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                                        <div className="relative flex items-center gap-4">
                                            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                                                {image?.[0]?.image ? (
                                                    <Images height={24} source={image[0].image} alt="currency" />
                                                ) : (
                                                    <DollarSign className="text-white" size={20} />
                                                )}
                                            </div>

                                            <div className="flex-1">
                                                <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-3 gap-3">
                                                    <div>
                                                        <h3 className="text-white font-bold text-lg mb-1">Pending Deposit</h3>
                                                        <div className="flex items-center gap-2">
                                                            <Receipt className="text-gray-400" size={14} />
                                                            <span className="text-gray-300 text-sm font-mono break-all">{item.txn_id}</span>
                                                            <CopyToClipboard text={item.txn_id}>
                                                                <button className="text-gray-400 hover:text-white transition-colors p-1 rounded hover:bg-white/10">
                                                                    <Copy size={12} />
                                                                </button>
                                                            </CopyToClipboard>
                                                        </div>
                                                    </div>
                                                    <div className={`px-3 py-2 rounded-2xl ${currentStatus.bgColor} border ${currentStatus.borderColor} flex items-center gap-2 shadow-lg`}>
                                                        <currentStatus.icon className={currentStatus.color} size={16} />
                                                        <span className={`text-sm font-semibold ${currentStatus.color}`}>
                                                            {currentStatus.label}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="bg-white/5 rounded-2xl p-4 border border-white/10">
                                                    <div className="flex items-center gap-2 mb-2">
                                                        <DollarSign className="text-blue-400" size={14} />
                                                        <span className="text-gray-300 text-sm font-medium">Amount to Pay</span>
                                                    </div>
                                                    <p className="text-white font-bold text-xl">
                                                        {money(item?.amountEnforcedToPay, item?.currency)}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Progress indicator */}
                                        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-500 to-blue-500 opacity-60"></div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-white/10">
                            <button
                                onClick={() => setIsOpen(false)}
                                className="flex-1 py-4 px-6 bg-white/10 border border-white/20 rounded-2xl text-white hover:bg-white/20 transition-all duration-300 font-medium hover:scale-105"
                            >
                                Close
                            </button>
                            <button
                                onClick={() => {
                                    setIsOpen(false);
                                    navigate('/deposit');
                                }}
                                className="flex-1 py-4 px-6 rounded-2xl font-semibold text-white transition-all duration-300 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 hover:scale-105 shadow-lg hover:shadow-blue-500/25 flex items-center justify-center gap-2"
                            >
                                <History size={18} />
                                Contine payment process
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </SiteWide>
    );
}

export default DepositHistory;